import styled from "styled-components/macro";
import { media } from "../../../../utils";

export const Carroussel = styled.div({});

export const SectionHeadline = styled.span(({ theme }) => ({
  color: theme.color.neutral["03"],
}));

export const CoberturarBasicasContent = styled.div({
  [media.lg()]: {
    display: "flex",
    justifyContent: "space-between",
    [`${SectionHeadline}`]: {
      textAlign: "left",
      color: "#500778",
    },
    [`${Carroussel}`]: {
      flexWrap: "nowrap",
      justifyContent: "space-between",
      width: "100%",
      maxWidth: "81%",
      paddingLeft: "32px",
    },
  },
});
